import type { LoaderFunction } from 'react-router';
import services from '../../services';
import type { Question } from '../../services/additionalInfo/model';

export interface QuestionsPageLoaderData {
  questions: Question[];
  questionsToken?: string;
  questionsAnswered: boolean;
}

const loader: LoaderFunction = async (
  args,
): Promise<QuestionsPageLoaderData> => {
  const { request } = args;
  const questionsToken = new URL(request.url).searchParams.get('token') || '';

  try {
    const { result, error } =
      await services.additionalInfo.getQuestions(questionsToken);

    if (result.length > 0 && !error) {
      return { questions: result, questionsToken, questionsAnswered: false };
    } else {
      // Currently we do not show different text for different error responses
      // (error && [400, 403, 500, 404].indexOf(error.status) > -1).
      // It might be useful to introduce different messages depending on error status.
      return { questions: [], questionsToken, questionsAnswered: true };
    }
  } catch (e) {
    // questions could not be loaded
  }
  return { questions: [], questionsAnswered: false };
};

export default loader;
